import { Page } from '@app/components/page/Page';
import { GroupIcon } from '@app/components/users/GroupIcon';
import { ListViewLocal } from '@app/core/list-view/ListViewLocal';
import { GroupFromIndex } from '@app/core/types/users';
import { fetchGroups } from '@app/modules/admin/api';
import { AddButton } from '@app/modules/admin/components/AddButton';
import { GroupsHelp } from '@app/modules/admin/components/GroupsHelp';
import { FormattedMessage, useIntl } from 'react-intl';
import { AdminGroupsList } from './AdminGroupsList';
import { ADMIN_GROUPS_FILTERS_CONFIG } from './filters/admin-groups-filters-config';

/**
 * Admin user-groups list: loads all groups once and filters locally via ListViewLocal.
 */
export function AdminGroupsListPage() {
  const { $t } = useIntl();

  const queryFn = async (): Promise<GroupFromIndex[]> => {
    return fetchGroups();
  };

  return (
    <Page
      data-cy="groups-list-screen"
      htmlTitle={$t({
        id: 'admin.groups.listScreen.title',
        defaultMessage: 'Administrar grupos',
      })}
    >
      <Page.Header
        icon={<GroupIcon />}
        title={
          <>
            <FormattedMessage
              id="admin.groups.listScreen.title"
              defaultMessage="Administrar grupos"
            />
            <GroupsHelp
              linkText={
                <FormattedMessage
                  id="admin.groups.addScreen.helpLinkText"
                  defaultMessage="¿Qué es un grupo?"
                />
              }
            />
          </>
        }
        actions={
          <AddButton
            to="/admin/groups/add"
            label={$t({
              id: 'admin.groups.listScreen.links.createGroup',
              defaultMessage: 'Crear grupo',
            })}
          />
        }
      />
      <ListViewLocal
        listId="admin-groups"
        filters={ADMIN_GROUPS_FILTERS_CONFIG}
        queryFn={queryFn}
        ListComponent={AdminGroupsList}
        ListWrapper={Page.Content}
        enablePagination={false}
        showProgress
      />
    </Page>
  );
}
